import type { FC } from "react";
import { Skeleton } from "../components/Skeleton";
import "./InboxSkeleton.css";

const CONVERSATION_KEYS = [
	"c0",
	"c1",
	"c2",
	"c3",
	"c4",
	"c5",
	"c6",
	"c7",
] as const;
const MESSAGE_BUBBLES = [
	{ key: "m0", incoming: true },
	{ key: "m1", incoming: false },
	{ key: "m2", incoming: true },
	{ key: "m3", incoming: false },
	{ key: "m4", incoming: true },
] as const;

export const InboxConversationListSkeleton: FC = () => (
	// biome-ignore lint/a11y/useSemanticElements: presentational loading placeholder
	<div
		className="inbox-skeleton-list"
		role="status"
		aria-busy="true"
		aria-label="Loading conversations"
	>
		{CONVERSATION_KEYS.map((key) => (
			<div key={key} className="inbox-skeleton-item">
				<Skeleton circle width={40} height={40} />
				<div className="inbox-skeleton-item-copy">
					<div className="inbox-skeleton-item-top">
						<Skeleton height={13} width="42%" />
						<Skeleton height={11} width="18%" />
					</div>
					<Skeleton height={12} width="78%" />
					<Skeleton height={11} width="58%" />
				</div>
			</div>
		))}
	</div>
);

export const InboxMessagesSkeleton: FC = () => (
	// biome-ignore lint/a11y/useSemanticElements: presentational loading placeholder
	<div
		className="inbox-skeleton-messages"
		role="status"
		aria-busy="true"
		aria-label="Loading messages"
	>
		<div className="inbox-skeleton-messages-header">
			<Skeleton circle width={36} height={36} />
			<div className="inbox-skeleton-item-copy">
				<Skeleton height={14} width="36%" />
				<Skeleton height={11} width="24%" />
			</div>
		</div>
		<div className="inbox-skeleton-messages-body">
			{MESSAGE_BUBBLES.map(({ key, incoming }) => (
				<div
					key={key}
					className={`inbox-skeleton-bubble ${incoming ? "incoming" : "outgoing"}`}
				>
					<Skeleton height={12} width={incoming ? "72%" : "58%"} />
					<Skeleton height={12} width={incoming ? "48%" : "40%"} />
				</div>
			))}
		</div>
	</div>
);
